const startSymptomQuestionnaire = document.querySelector( '[data-start-symptom-questionnaire]' );

if ( startSymptomQuestionnaire ) {
	startSymptomQuestionnaire.addEventListener( 'click', ( e ) => {
		e.preventDefault();
		const symptomsQuestionnaire = document.querySelector( '[data-symptoms-questionnaire-form]' );
		symptomsQuestionnaire.style.transition = 'max-height 1000ms ease-in-out, opacity 1000ms ease-in-out';
		symptomsQuestionnaire.style.maxHeight = '500vh';
		symptomsQuestionnaire.style.height = 'auto';
		symptomsQuestionnaire.style.opacity = '1';
		startSymptomQuestionnaire.style.transition = 'opacity 1000ms ease-in-out';
		startSymptomQuestionnaire.style.opacity = '0';
		const questionnaireFormInner = document.querySelector( '.questionnaire-form-inner' );
		questionnaireFormInner.classList.remove( 'dn' );
		setTimeout( () => {
			startSymptomQuestionnaire.style.display = 'none';
		}, 1250 );
	} );

}
